import { AlertService } from '../../shared/alert/alert.service';

/**
 * Ugly Workaround to catch errors
 * TODO brapi-js catch errors
 * @param brapi the brapi node object
 * @param timeout to reject
 */
export function brapiAll(brapi: any, timeout = 5000): Promise<any> {
    return new Promise((resolve, reject) => {
        brapi.all((res: any) => resolve(res));
        setTimeout(reject, timeout);
    });
}

export function toText(items: Array<{ message?: string }>) {
    return items
        .map(x => x.message)
        .filter((m): m is string => Boolean(m && m.trim()))
        .join('<br><br>');
}

export function handleStatusMessages(
    status: any[],
    alertService: AlertService, showBoth = false
): { errors: any[], info: any[], hasErrors: boolean } {

    const errors = status?.filter((s: any) => s.messageType === 'ERROR');
    const info = status?.filter((s: any) => s.messageType === 'INFO');

    if (errors.length) {
        alertService.error('error.custom', { param: toText(errors) });
    } else if (info.length) {
        alertService.success('success.custom', { param: toText(info) });
    }

    return { errors, info, hasErrors: errors.length > 0 };
}

